import { FeedbackType } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { useMutation } from 'react-query';
import { SchemaTaskCenter } from '../../service';
import { IO } from '../../types';

export const useSubmitTaskFeedback = () =>
  useMutation((params: Omit<IO.SubmitTaskFeedback['input'], 'feedbackType'>) =>
    SchemaTaskCenter.SubmitTaskFeedback({ ...params, feedbackType: FeedbackType.FEEDBACK_TYPE_AI_TASK_DETAILS })
  );
